// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2QYS6","productName":"Table_productName__3QSrz"};